module.exports = __webpack_public_path__ + "static/media/51.7339382a.jpg";